import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";
import { toast } from "sonner";

import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Loading } from "../../components/shared";

export default function ResidentMyUnits() {
  const [units, setUnits] = useState(null);
  const navigate = useNavigate();

  const load = () => api.get("/resident/units").then((response) => setUnits(response.data));

  useEffect(() => {
    load();
  }, []);

  const selectUnit = async (unitId) => {
    try {
      await api.post("/resident/context", { unit_id: unitId });
      toast.success("Home context updated");
      load();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Could not update your home context");
    }
  };

  if (!units) return <Loading />;

  return (
    <div data-testid="resident-my-units-page">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">My Units</p>
      <h1 className="mt-2 font-display text-4xl font-bold text-slate-900">Your connected homes</h1>
      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        {units.map((unit) => (
          <article
            className="border border-slate-200 bg-white p-5"
            data-testid={`resident-unit-${unit.unit_id}`}
            key={unit.unit_id}
          >
            <Home className="h-5 w-5 text-primary" />
            <h2 className="mt-4 font-display text-xl font-semibold text-slate-900">
              Unit {unit.unit_number}
            </h2>
            <p className="mt-1 text-sm text-slate-600">
              {[unit.floor, unit.unit_type].filter(Boolean).join(" · ") || "Home"}
            </p>
            <p className="mt-4 text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">
              {unit.relationship_roles.join(" · ")}
            </p>
            {unit.active ? (
              <div className="mt-5 flex flex-wrap items-center gap-3">
                <p className="text-sm font-medium text-emerald-700" data-testid={`resident-unit-active-${unit.unit_id}`}>
                  Active home context
                </p>
                <Button data-testid={`resident-unit-detail-${unit.unit_id}`} onClick={() => navigate("/resident/unit")} size="sm" variant="outline">
                  View details
                </Button>
              </div>
            ) : (
              <Button
                className="mt-5"
                data-testid={`resident-select-unit-${unit.unit_id}`}
                onClick={() => selectUnit(unit.unit_id)}
                variant="outline"
              >
                Use this home
              </Button>
            )}
          </article>
        ))}
      </div>
    </div>
  );
}